<!doctype html>
<html lang="en" xmlns="http://www.w3.org/1999/html">
<head>

  <!-- Basic Page Needs
  ================================================== -->
  <title>ระบบค้นหาและแนะนำรหัสประเภทธุรกิจ - กรมพัฒนาธุรกิจการค้า</title>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">
  <base href="/searchResult">

</head>
<body class="gray">
<!-- Wrapper -->
<div id="overlay">
	<div class="cv-spinner">
		<span class="spinner"></span>
	</div>
</div>

<div id="wrapper">
  <app-header-mainsearch-result></app-header-mainsearch-result>

  <div class="clearfix"></div>
  <!-- Header Container / End -->

  <!-- Spacer -->
  <div class="margin-top-30"></div>
  <!-- Spacer / End-->

  <!-- Page Content
================================================== -->
  <div class="container">
    <div class="row">

      <!--<div class="col-xl-4">
        <div class="sidebar-container">
          <div class="dashboard-box child-box-in-row">
            <div class="headline">
              <h3><i class="icon-feather-filter"></i> กรองข้อมูลจากผลการค้นหา (Filters)</h3>
            </div>

            <div class="content with-padding">
              &lt;!&ndash; Note &ndash;&gt;
              <div class="dashboard-note">
                <p><strong>ระบุคำค้นเพิ่มเติม</strong></p>
                <div class="keywords-container">
                  <div class="keyword-input-container">
                    <input type="text" class="keyword-input" placeholder="กรอกคำค้นแล้วกดปุ่ม Enter"/>
                    <button class="keyword-input-button ripple-effect"><i class="icon-material-outline-add"></i>
                    </button>
                  </div>
                  <div class="keywords-list">&lt;!&ndash; keywords go here &ndash;&gt;</div>
                  <div class="clearfix"></div>
                </div>
              </div>
              &lt;!&ndash; Note &ndash;&gt;
              <div class="dashboard-note">
                <p><strong>เลือกประเภทกิจการ</strong></p>
                <div class="switches-list">
                  <div class="switch-container">
                    <label class="switch"><input type="checkbox" checked><span class="switch-button"></span>
                      ผลิต</label>
                  </div>

                  <div class="switch-container">
                    <label class="switch"><input type="checkbox" checked><span class="switch-button"></span>
                      ส่งออก</label>
                  </div>

                  <div class="switch-container">
                    <label class="switch"><input type="checkbox" checked><span class="switch-button"></span>
                      ขายส่ง</label>
                  </div>

                  <div class="switch-container">
                    <label class="switch"><input type="checkbox" checked><span class="switch-button"></span>
                      ขายปลีก</label>
                  </div>
                  <div class="switch-container">
                    <label class="switch"><input type="checkbox" checked><span class="switch-button"></span>
                      บริการ</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="add-note-button">
              <a href="" class="popup-with-zoom-anim button full-width button-sliding-icon">ค้นหา <i
                class="icon-material-outline-arrow-right-alt"></i></a>
            </div>
          </div>
          &lt;!&ndash; Dashboard Box / End &ndash;&gt;
        </div>
      </div>-->

      <!--<div class="col-xl-8 col-lg-8 content-left-offset">-->
      <div class="col-xl-12 col-lg-12 content-left-offset">
        <div class="row">
          <div class="col-md-8">
              <h3 class="page-title" style="font-family: 'Kanit'" id="sumResult"></h3>
          </div>
          <div class="col-md-4" style="font-family: 'Kanit'">
            <div class="sort-by">
                <span>เรียงลำดับตาม </span>
                <div class ="selectSortDataM">
                  <select id="selectSortData" class="custom-select" style="height: 45px; margin-top: -9px; margin-left: 10%; background-color: #ffffff; color: rgb(99, 99, 99); font-family: 'Kanit'" >
                    <option value="SCORE">คำแนะนำของระบบ</option>
                    <option value="CODE">TSIC CODE</option>
                    <option value="TITLE">TSIC TITLE</option>
                  </select>

                </div>
            </div>
          </div>
        </div>

        <div class="notify-box margin-top-15">
          <!-- <div class="switch-container">
            <label class="switch"><input type="checkbox" checked="checked" id="chkShowService"><span class="switch-button"></span><span
              class="switch-text">แสดงรายชื่อสินค้าและบริการ</span></label>
          </div> -->
          <div class="row" style="font-family: 'Kanit'">
            <div class="col-md-12">
              <div class="intro-banner-search-form margin-top-5">

                <!-- Search Field -->
                <div class="intro-search-field">
                      <!-- <label for="txtSearch" class="field-title ripple-effect" style="font-family: 'Chakra Petch'">กรุณาระบุคำค้น</label> -->
                      <!-- <select #selectType id="selectType" > -->
                        <select #selectType class="custom-select">
                          <option value="0">ทุกประเภทกิจการ</option>
                          <option value="1">ผลิต</option>
                          <option value="2">ขายส่ง</option>
                          <option value="3">ขายปลีก</option>
                          <option value="4">บริการ</option>
                        </select>
                </div>
                <input #textSearch id="txtSearch" type="text"  placeholder="ระบุกิจกรรมทางธุรกิจ เช่น ขายเสื้อผ้าออนไลน์ หรือรหัสธุรกิจที่ต้องการ เช่น 47912" (keyup.Enter)="searchData(textSearch.value, selectType.value)" style="margin-top: auto; margin-bottom: auto;"><!-- $event.target.value -->
                <!-- Button -->
                <div class="intro-search-button">
                  <button class="button ripple-effect" id="btnSearchResult" (click)="searchData(textSearch.value, selectType.value)" style="height: 100%; font-family: 'Kanit'">ค้นหา </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tasks Container -->
        <div class="tasks-list-container margin-top-35">
          <!-- Task -->
          <div id="show-content"></div>


        <!-- Pagination -->
        <div class="clearfix"></div>
        <div class="row">
          <div class="col-md-12">
            <!-- Pagination -->
            <div class="pagination-container margin-top-30 margin-bottom-60" >
              <div id="pagingnation-content"></div>
            </div>
          </div>
        </div>
        <!-- Pagination / End -->

      </div>
      <!-- Tasks Container / End -->

    </div>

  </div>
  </div>

<!-- Footer
================================================== -->
<div id="footer">

  <!-- Footer Copyrights -->
  <div class="footer-bottom-section">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          จัดทำโดย กรมพัฒนาธุรกิจการค้า กระทรวงพาณิชย์ (สนามบินน้ำ) 563 ถ.นนทบุรี ต.บางกระสอ อ.เมือง จ.นนทบุรี 11000
        </div>
        <div class="col-xl-12">
          © 2020 <strong>Department of Business Development</strong>. All Rights Reserved.
        </div>
      </div>
    </div>
  </div>
  <!-- Footer Copyrights / End -->

</div>
<!-- Footer / End -->

</div>
<!-- Wrapper / End -->

<!-- Bid Acceptance Popup
================================================== -->
<div id="small-dialog-1" class="zoom-anim-dialog mfp-hide dialog-with-tabs">

  <!--Tabs -->
  <div class="sign-in-form">

    <ul class="popup-tabs-nav">
      <li><a href="#tab1"><i class="icon-feather-user-check"></i> กรมพัฒนาธุรกิจการค้า</a></li>
    </ul>

    <div class="popup-tabs-container">

      <!-- Tab -->
      <div class="popup-tab-content" id="tab">

        <!-- Welcome Text -->
        <div class="welcome-text">
          <h3>ขอบคุณสำหรับคำแนะนำของท่าน</h3>
        </div>

        <!-- Button -->
        <!--<button class="margin-top-15 button full-width button-sliding-icon ripple-effect" type="submit" form="terms">
          ตกลง <i class="icon-material-outline-arrow-right-alt"></i></button>-->
        <button class="margin-top-15 button full-width button-sliding-icon ripple-effect" id="btnOK">
          ตกลง <i class="icon-material-outline-arrow-right-alt"></i></button>

      </div>

    </div>
  </div>
</div>

<!-- Bid Acceptance Popup / End -->

<!-- Send Direct Message Popup
================================================== -->
<div id="small-dialog-2" class="zoom-anim-dialog mfp-hide dialog-with-tabs">

  <!--Tabs -->
  <div class="sign-in-form">

    <ul class="popup-tabs-nav">
      <li><a href="#tab1"><i class="icon-feather-user-x"></i> กรมพัฒนาธุรกิจการค้า</a></li>
    </ul>

    <div class="popup-tabs-container">

      <!-- Tab -->
      <div class="popup-tab-content" id="tab2">

        <!-- Welcome Text -->
        <div class="welcome-text">
          <h3>กรุณาระบุความคิดเห็นของท่าน</h3>
        </div>

        <!-- Form -->
        <form method="post" id="send-pm">
          <textarea name="textarea" id="textareaMessage" cols="10" placeholder="พิมพ์ที่นี่" class="with-border" required></textarea>
        </form>

        <!-- Button -->
        <button class="button full-width button-sliding-icon ripple-effect" id="btnSendMessage" type="submit" form="send-pm">ส่งข้อความ <i
          class="icon-material-outline-arrow-right-alt"></i></button>

      </div>

    </div>
  </div>
</div>
<!-- Send Direct Message Popup / End -->
</body>
</html>
